function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M30.29,32.59c.82.65,1.85,1.01,2.9,1.01h13.62c1.05,0,2.08-.36,2.9-1.01.82-.65,1.4-1.58,1.64-2.6l1.6-6.91c-.97-.15-1.95-.29-2.94-.41l-1.54,6.66c-.18.78-.86,1.32-1.66,1.32h-13.62c-.8,0-1.48-.54-1.66-1.32l-1.54-6.66c-.99.12-1.97.25-2.94.41l1.6,6.91c.24,1.02.82,1.95,1.64,2.6Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M63.67,17.92l-.05-.65c-.11-1.37-1.07-2.52-2.4-2.85-2-.5-4.09-.96-6.21-1.35-.79-.15-1.61.01-2.29.44-.68.43-1.17,1.1-1.38,1.88v.02c1.37.17,2.74.38,4.09.61,2.86.5,5.62,1.14,8.24,1.9Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M25.04,15.94c.15-.03.3-.06.46-.09.03,0,.06,0,.09,0,.97-.16,1.95-.3,2.94-.42h0c-.2-.75-.67-1.39-1.33-1.8-.65-.41-1.43-.56-2.2-.42-2.12.39-4.2.84-6.2,1.35-1.28.32-2.2,1.42-2.3,2.74l-.05.6c2.59-.75,5.3-1.37,8.11-1.86.16-.03.31-.05.47-.08Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M75.96,45.97c-.95-7.23-2.28-13.14-3.94-17.56-1.38-3.67-2.66-5.38-3.2-6.11l-.29-.39-.4-.15c-1.38-.53-2.8-1.02-4.27-1.47-.99-.3-2-.59-3.03-.85-1.87-.48-3.79-.89-5.77-1.24-.37-.06-.74-.13-1.11-.19-.08-.01-.15-.02-.23-.04-.84-.13-1.69-.25-2.54-.36-.14-.02-.27-.03-.41-.05-3.51-.43-7.11-.64-10.76-.64s-7.34.22-10.89.66c-.09.01-.19.02-.28.04-.81.1-1.61.22-2.41.34-.12.02-.24.04-.35.06-.37.06-.74.12-1.11.19-2.03.35-4,.78-5.9,1.27-.94.24-1.86.5-2.77.77-1.52.46-2.98.96-4.4,1.51l-.4.15-.29.39c-.55.73-1.82,2.44-3.2,6.11-1.66,4.42-2.99,10.33-3.94,17.56-.45,3.4-.44,6.51.02,9.24.41,2.42,1.18,4.56,2.28,6.36.95,1.55,2.13,2.83,3.5,3.78,1.47,1.02,2.78,1.41,3.62,1.56,1.03.18,2.09,0,3.01-.51.91-.51,1.63-1.32,2.01-2.29v-.03s4.7-13.34,4.7-13.34c.06-.14.12-.27.19-.4-.5-.59-.9-1.25-1.2-1.96-.12-.29-.23-.58-.31-.88-.62.61-1.11,1.35-1.44,2.17v.03s-4.7,13.34-4.7,13.34c-.29.68-1.02,1.09-1.75.96-1.45-.26-3.55-1.43-5.11-3.97-.9-1.48-1.54-3.26-1.88-5.31-.41-2.44-.41-5.25,0-8.36.92-7.01,2.19-12.7,3.78-16.91,1.08-2.87,2.03-4.32,2.59-5.09,3.7-1.4,7.77-2.49,12.12-3.25.36-.06.73-.12,1.09-.18.97-.16,1.95-.29,2.94-.41,3.42-.42,6.94-.63,10.5-.63s7.08.21,10.5.63c.99.12,1.97.26,2.94.41.37.06.73.12,1.09.18,4.34.76,8.42,1.85,12.12,3.25.56.77,1.51,2.22,2.59,5.09,1.58,4.21,2.86,9.9,3.78,16.91.41,3.11.41,5.92,0,8.36-.35,2.05-.98,3.83-1.88,5.31-1.56,2.54-3.66,3.72-5.11,3.97-.73.13-1.46-.27-1.75-.96l-4.68-13.31v-.03s-.02-.03-.02-.03c-.32-.79-.79-1.51-1.38-2.11-.08.28-.18.55-.29.82-.31.74-.73,1.41-1.25,2.02.06.11.11.22.16.34l4.68,13.31v.03s.02.03.02.03c.39.97,1.1,1.78,2.01,2.29.68.38,1.45.58,2.22.58.26,0,.53-.02.79-.07,1.52-.27,2.8-1,3.62-1.56,1.37-.95,2.55-2.23,3.5-3.78,1.1-1.8,1.87-3.94,2.28-6.36.46-2.73.47-5.84.02-9.24Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M43.16,47.04c-.99.05-2.04.08-3.16.08s-2.12-.03-3.09-.07c-.1.46-.24.91-.43,1.34-.23.55-.52,1.07-.87,1.54,1.35.09,2.8.14,4.39.14s3.09-.05,4.46-.15c-.35-.48-.64-.99-.87-1.54-.19-.44-.33-.89-.43-1.35Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M33.26,41.42c-1.05-1.05-2.45-1.63-3.94-1.63s-2.88.58-3.94,1.63c-.67.67-1.14,1.47-1.4,2.35-.15.51-.23,1.04-.23,1.59,0,.27.02.54.06.81.14.99.55,1.92,1.19,2.71.12.14.24.28.38.42,1.05,1.05,2.45,1.63,3.94,1.63,1.3,0,2.54-.44,3.53-1.26.14-.12.28-.24.41-.37.68-.68,1.16-1.51,1.42-2.41.14-.49.21-1,.21-1.52,0-.23-.01-.45-.04-.67-.15-1.23-.7-2.37-1.59-3.26ZM29.33,47.97c-1.34,0-2.45-1.02-2.59-2.32-.01-.09-.02-.19-.02-.29,0-.72.3-1.38.77-1.85.47-.47,1.12-.76,1.83-.76,1.06,0,1.97.63,2.38,1.54.15.33.23.69.23,1.07,0,.41-.1.8-.27,1.15-.43.86-1.31,1.46-2.34,1.46Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M54.69,41.42c-1.05-1.05-2.45-1.63-3.94-1.63s-2.88.58-3.94,1.63c-.89.89-1.44,2.03-1.59,3.26-.03.22-.04.45-.04.68,0,.52.07,1.03.21,1.52.25.91.74,1.74,1.42,2.42.13.13.26.25.4.36.99.82,2.23,1.27,3.54,1.27,1.49,0,2.88-.58,3.94-1.63.13-.13.25-.26.36-.39.64-.78,1.06-1.71,1.21-2.7.04-.28.06-.56.06-.84,0-.54-.08-1.06-.22-1.56-.26-.89-.74-1.7-1.41-2.37ZM48.14,45.36c0-.39.08-.75.24-1.09.41-.9,1.32-1.52,2.37-1.52.71,0,1.35.29,1.83.75.48.47.78,1.13.78,1.86,0,.1,0,.19-.02.28-.14,1.3-1.25,2.32-2.59,2.32-1.03,0-1.92-.6-2.34-1.47-.17-.34-.26-.73-.26-1.14Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M58.16,34.3c0-.92-.75-1.67-1.67-1.67s-1.67.75-1.67,1.67.75,1.67,1.67,1.67,1.67-.75,1.67-1.67Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M65.47,35.98c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67-1.67.75-1.67,1.67.75,1.67,1.67,1.67Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M60.98,31.48c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67-1.67.75-1.67,1.67.75,1.67,1.67,1.67Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M60.98,40.47c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67-1.67.75-1.67,1.67.75,1.67,1.67,1.67Z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M16.22,32.72h-2.02c-.31,0-.55.25-.55.55v1.95c0,.31.25.55.55.55h2.02c.15,0,.29-.06.39-.16l1.14-1.14c.12-.12.12-.33,0-.45l-1.14-1.14c-.1-.1-.24-.16-.39-.16Z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M21.39,28.6c0-.31-.25-.55-.55-.55h-1.95c-.31,0-.55.25-.55.55v2.02c0,.15.06.29.16.39l1.14,1.14c.12.12.33.12.45,0l1.14-1.14c.1-.1.16-.24.16-.39v-2.02Z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M26.07,35.23v-1.95c0-.31-.25-.55-.55-.55h-2.02c-.15,0-.29.06-.39.16l-1.14,1.14c-.12.12-.12.33,0,.45l1.14,1.14c.1.1.24.16.39.16h2.02c.31,0,.55-.25.55-.55Z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M20.09,36.36c-.12-.12-.33-.12-.45,0l-1.14,1.14c-.1.1-.16.24-.16.39v2.02c0,.31.25.55.55.55h1.95c.31,0,.55-.25.55-.55v-2.02c0-.15-.06-.29-.16-.39l-1.14-1.14Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/Esports-inactive.cdde3e57.svg";
export { SvgComponent as ReactComponent };